/**
 * app color palette
 */

// @TODO: don't use d3Color in here, it's too weird

import colors from 'vuetify/es5/util/colors';
import { color as d3Color } from 'd3';

// layout
export const primary = colors.indigo.base;
export const secondary = colors.blueGrey.lighten3;
export const accent = colors.indigo.accent1;
// - navigation
export const navIcon = primary;
export const navIconActive = accent;

// map makers
export const markerStroke = d3Color(colors.shades.white);
export const markerStrokeActiveAppl = d3Color('#E3A82B');
export const markerSelected = d3Color(colors.green.accent3);
export const markerSelectedStroke = d3Color(colors.shades.black);
export const markerUnknown = d3Color('#CCCCCC');

// station map markers
export const markerHistorical = d3Color('#5A8ED1');
export const markerCurrent = d3Color('#F17D43');

// licence map markers
export const markerSwShort = d3Color('#F8B422');
export const markerSwLong = d3Color('#224A86');
export const markerGwShort = d3Color('#47C0F7');
export const markerGwLong = d3Color('#B660C5');

// polygon map layers
export const watershedPolygon = d3Color(colors.orange.accent4);
export const studyAreaMask = d3Color(colors.shades.white);

// sparkline colors
export const sparklineColor1 = d3Color(colors.indigo.darken2);
export const sparklineColor2 = d3Color(colors.lightBlue.darken1);
export const sparklineBgColor = d3Color(colors.blueGrey.lighten4);
sparklineBgColor.opacity = 0.6;

// station chart colors
export const waterBorder = d3Color(colors.lightBlue.lighten2);
export const waterBg = d3Color(colors.lightBlue.lighten3);
waterBg.opacity = 0.6;
export const currentBorder = d3Color(colors.orange.lighten2);
export const currentBg = d3Color(colors.orange.lighten3);
currentBg.opacity = 0.3;
export const historicalMedian = d3Color(colors.blueGrey.darken2);
export const historicalMean = d3Color(colors.blueGrey.darken2);
export const historical1 = d3Color(colors.blueGrey.lighten2);
export const historical2 = d3Color(colors.blueGrey.lighten3);
export const todayMarker = colors.orange.lighten2; //  some reason if I wrap this in d3Color it turns up grey.

// axis/gridline colors
export const axisBorder = d3Color(colors.grey.lighten2);



// WEBPACK FOOTER //
// ./src/functions/appColors.js